import { User } from "@common/types/user";

export const getTaskAssigneeDisplayName = (
    user: Pick<User, "name"> & Partial<Pick<User, "firstName" | "lastName">>,
): string => {
    const fullName = `${user.firstName ?? ""} ${user.lastName ?? ""}`.trim();
    return user.name ?? fullName ?? "Unknown";
};
